import { Component, markRaw } from 'vue';
import StepOneCompteur from '@/modules/Outils/components/StepOneCompteur.vue';
import StepTwoCompteur from '@/modules/Outils/components/StepTwoCompteur.vue';
import StepThreeCompteur from '@/modules/Outils/components/StepThreeCompteur.vue';

export enum Civilite {
    monsieur = 'Monsieur',
    madame = 'Madame'
}

export class Compteur {
    numeroCompteur = '';
    facture: File | undefined = undefined;
}

export interface CompteurState {
    step: number,

    raisonSociale: string,
    nomCommercial: string,
    numeroIdentifiant: string,
    adressePostale: string,
    codePostal: number | undefined,
    ville: string,

    civilite: Civilite,
    nomRepresentant: string,
    prenomRepresentant: string,
    dateNaissanceRepresentant: string,
    emailRepresentant: string,
    adresseRepresentantIdentique: boolean,
    adresseRepresentant: string,
    codePostalRepresentant: number | undefined,
    villeRepresentant: string,

    compteurs: Compteur[] | undefined,

    steps: Component[]
}

export const initialState: CompteurState = {
    step: 0,

    raisonSociale: '',
    nomCommercial: '',
    numeroIdentifiant: '',
    adressePostale: '',
    codePostal: undefined,
    ville: '',

    civilite: Civilite.monsieur,
    nomRepresentant: '',
    prenomRepresentant: '',
    dateNaissanceRepresentant: '',
    emailRepresentant: '',
    adresseRepresentantIdentique: true,
    adresseRepresentant: '',
    codePostalRepresentant: undefined,
    villeRepresentant: '',

    compteurs: [new Compteur()],
    steps: [ markRaw(StepOneCompteur), markRaw(StepTwoCompteur), markRaw(StepThreeCompteur) ],
};

export const state: CompteurState = {
    ...initialState
};
